import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

/**
 * Stats of Product Schema
 * Represents a status of product that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const StatsSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    totalClicks: Yup.number().nullable(),
    uniqueClicks: Yup.number().nullable(),
    totalSales: Yup.number().nullable(),
  })

/**
 * Stats of Product Validation Schema
 * Strict rules applied only during form submission.
 */
export const StatsValidationSchema = StatsSchema.clone().shape({
  totalClicks: Yup.number().min(0).required(),
  uniqueClicks: Yup.number().min(0).required(),
  totalSales: Yup.number().min(0).required(),
})
